import "./App.css";
import AllRoutes from "./Routes";

function App() {
  return (
    <div className="min-h-screen bg-gray-300 px-2">
      {/* <Card/> */}
      <AllRoutes />
      {/* <Home/> */}
    </div>
  );
}

export default App;
